export const TEMPLATE_NAME_PATTERN = /^[a-z0-9_]+$/;
export const MAX_QUICK_REPLIES = 3;
export const MAX_QUICK_REPLY_LENGTH = 25;
export const TEMPLATE_CATEGORIES = ['MARKETING', 'UTILITY'];
export const TEMPLATE_LANGUAGES = [
  'pt_BR',
  'en_US',
  'en',
  'es',
  'es_AR',
  'es_MX',
  'fr',
  'de',
  'it',
  'pt_PT',
  'hi',
  'ar',
];

export const isValidTemplateName = name =>
  TEMPLATE_NAME_PATTERN.test(name || '');

export const extractVariables = body => {
  const matches = String(body || '').match(/\{\{(\d+)\}\}/g) || [];
  return [...new Set(matches.map(match => Number(match.replace(/\D/g, ''))))]
    .filter(Number.isInteger)
    .sort((first, second) => first - second);
};

const cleanReplies = quickReplies =>
  (quickReplies || [])
    .map(reply => String(reply || '').trim())
    .filter(Boolean)
    .slice(0, MAX_QUICK_REPLIES);

export const areVariablesSequential = body => {
  const variables = extractVariables(body);
  return variables.every((value, index) => value === index + 1);
};

export const validateTemplateForm = ({
  name,
  category,
  language,
  body,
  quickReplies,
}) => {
  const errors = {};
  if (!isValidTemplateName(name)) errors.name = 'name';
  if (!TEMPLATE_CATEGORIES.includes(category)) errors.category = 'category';
  if (!language) errors.language = 'language';
  if (!String(body || '').trim()) {
    errors.body = 'body';
  } else if (!areVariablesSequential(body)) {
    errors.body = 'variables';
  }

  const rawReplies = (quickReplies || []).map(reply =>
    String(reply || '').trim()
  );
  if (rawReplies.filter(Boolean).length > MAX_QUICK_REPLIES) {
    errors.quickReplies = 'too_many';
  } else if (rawReplies.some(reply => reply.length > MAX_QUICK_REPLY_LENGTH)) {
    errors.quickReplies = 'too_long';
  }

  return errors;
};

export const buildTemplatePayload = ({
  name,
  category,
  language,
  body,
  quickReplies,
}) => ({
  name,
  category,
  language,
  body,
  quick_replies: cleanReplies(quickReplies),
});

export const buildPreviewTemplate = ({
  name,
  language,
  category,
  body,
  quickReplies,
}) => {
  const replies = cleanReplies(quickReplies);
  return {
    name,
    language,
    category,
    components: [
      { type: 'BODY', text: body || '' },
      ...(replies.length
        ? [
            {
              type: 'BUTTONS',
              buttons: replies.map(text => ({ type: 'QUICK_REPLY', text })),
            },
          ]
        : []),
    ],
  };
};

export const extractDuplicateDraft = template => {
  const components = template?.components || [];
  const bodyText =
    components.find(component => component.type === 'BODY')?.text || '';
  const buttons =
    components.find(component => component.type === 'BUTTONS')?.buttons || [];
  const category = String(template?.category || 'MARKETING').toUpperCase();

  return {
    name: `${template?.name || 'template'}_copy`
      .toLowerCase()
      .replace(/[^a-z0-9_]/g, '_'),
    category: TEMPLATE_CATEGORIES.includes(category) ? category : 'MARKETING',
    language: template?.language || 'pt_BR',
    body: bodyText,
    quickReplies: buttons
      .filter(button => button.type === 'QUICK_REPLY' && button.text)
      .map(button => button.text)
      .slice(0, MAX_QUICK_REPLIES),
  };
};
